import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { Exercise } from '../types';

import { getExercisesQuery, GetExercisesQueryResult, GetExercisesQueryVariables } from '../graphql/queries/getExercisesQuery';

type ExercisesHookResult = DataFetcherHookResult<Exercise[], 'exercises'>;

interface ExercisesHookInput {
  courseId: string;
  subjectId: string;
}

export default function useExercises(input: ExercisesHookInput): ExercisesHookResult {
  const { courseId, subjectId } = input;
  const { data, loading, error } = useQuery<GetExercisesQueryResult, GetExercisesQueryVariables>(getExercisesQuery, {
    variables: { courseId, subjectId },
  });

  return { loading, error: getErrorMessage({ error }), exercises: data?.exercises };
}
